import React from 'react';
import { IconTextButton } from 'ui-lib';

import { ISignAndCreateConfigurationFileResult } from 'dto/configuration-dto';

import configurationCss from './configuration.css';

export interface IConfigurationSigningFinishedProps {
    signedInfo: ISignAndCreateConfigurationFileResult;
    onClick: () => void;
}

const displayDebianFileKeys = ['name', 'version'];
const displayPackageKeys = ['label', 'key', 'version', 'type', 'fileName'];

export const ConfigurationSigningFinished = (props: IConfigurationSigningFinishedProps): JSX.Element => {

    const buildDetails = (title: string, info: any, displayKeys: string[]): JSX.Element => {
        return (
            <div>
                <strong>{title}</strong>
                <ul>
                    {displayKeys.map((key) => (
                        <li key={key}>
                            <strong>{key}: </strong>
                            <span>{info[key]}</span>
                        </li>
                    ))}
                </ul>
            </div>

        );
    };

    return (
        <div className={configurationCss.formFinished}>
            <div className={configurationCss.message}>{props.signedInfo?.message}</div>
            {buildDetails('Configuration file', props.signedInfo?.debianFile || {}, displayDebianFileKeys)}
            {buildDetails('Package', props.signedInfo?.package || {}, displayPackageKeys)}

            <IconTextButton
                label='Back to Upload files'
                type='primary'
                onClick={props.onClick}
            />
        </div>
    );
};
